<template>
  <div id="city-header">
    <v-row>
      <v-col class="cityName">
        <h2>{{ city }}</h2>

        <div v-if="isFullAdmin">
          <combobox-municipio
            @onChange="onChangeMunicipio"
          ></combobox-municipio>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-bottom-navigation :value="activeBtn" color="primary">
          <v-divider vertical></v-divider>

          <v-btn :to="'/cidade/' + cityId">
            <span>Geral</span>
          </v-btn>

          <v-divider
            vertical
            v-if="
              isFullAdmin ||
              ((isIndicadores || !isIndicadores) &&
                config.acompanhamentos &&
                groupsConfig.acompanhamentos)
            "
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/acompanhamento'"
            v-if="
              isFullAdmin ||
              ((isIndicadores || !isIndicadores) &&
                config.acompanhamentos &&
                groupsConfig.acompanhamentos)
            "
          >
            <span>Acompanhamentos</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              ((!isNA || (config.relatorios && groupsConfig.relatorios)) &&
                !isIndicadores &&
                !isSala)
            "
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/relatorio'"
            v-if="
              isFullAdmin ||
              ((!isNA || (config.relatorios && groupsConfig.relatorios)) &&
                !isIndicadores &&
                !isSala)
            "
          >
            <span>Relatórios</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              ((!isNA || (config.calendario && groupsConfig.calendario)) &&
                !isIndicadores &&
                !isSala)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/evento'"
            v-if="
              isFullAdmin ||
              ((!isNA || (config.calendario && groupsConfig.calendario)) &&
                !isIndicadores &&
                !isSala)
            "
          >
            <span>Calendário</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (groupsConfig.evidencias && config.evidencias)"
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/evidencia/respondida'"
            v-if="isFullAdmin || (groupsConfig.evidencias && config.evidencias)"
          >
            <span>Evidências</span>
          </v-btn>

          <v-divider
            v-if="
              isFullAdmin ||
              ((!isNA || (config.grupos && groupsConfig.grupos)) &&
                !isIndicadores &&
                !isSala)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/grupo'"
            v-if="
              isFullAdmin ||
              ((!isNA || (config.grupos && groupsConfig.grupos)) &&
                !isIndicadores &&
                !isSala)
            "
          >
            <span>{{
              $store.state.uf === "AL" || isAT ? "Grupos/Temas" : "Grupos"
            }}</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              ((!isNA || (config.andamento && groupsConfig.andamento)) &&
                !isIndicadores &&
                !isSala)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/andamento'"
            v-if="
              isFullAdmin ||
              ((!isNA || (config.andamento && groupsConfig.andamento)) &&
                !isIndicadores &&
                !isSala)
            "
          >
            <span>Andamento</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              ((!isNA ||
                (config.termoReferencia && groupsConfig.termoReferencia)) &&
                !isIndicadores &&
                !isSala)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/termo-referencia'"
            v-if="
              isFullAdmin ||
              ((!isNA ||
                (config.termoReferencia && groupsConfig.termoReferencia)) &&
                !isIndicadores &&
                !isSala)
            "
          >
            <span>Termos de Referência</span>
          </v-btn>
          <v-divider
            v-if="
              estado === 'SC1' && (isAdmin || isConsultorEspecialistaMunicipio)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/evento-em-lote'"
            v-if="
              estado === 'SC1' && (isAdmin || isConsultorEspecialistaMunicipio)
            "
          >
            <span>Calendário em Lote</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              (config.relatorioAdministrativo &&
                groupsConfig.relatorioAdministrativo)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/relatorio-administrativo'"
            v-if="
              isFullAdmin ||
              (config.relatorioAdministrativo &&
                groupsConfig.relatorioAdministrativo)
            "
          >
            <span>Relatório Administrativo</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (config.sala && groupsConfig.sala)"
            vertical
          ></v-divider>
          <v-btn
            v-if="isFullAdmin || (config.sala && groupsConfig.sala)"
            :to="'/sala-municipio-principal'"
          >
            <span>Sala</span>
          </v-btn>
          <v-divider vertical></v-divider>
        </v-bottom-navigation>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComboboxMunicipio from "./ComboboxMunicipio.vue";

export default {
  components: { ComboboxMunicipio },
  props: {
    payload: { type: Object },
  },
  data() {
    return {
      activeBtn: 0,
      estado: this.$store.state.uf,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    onChangeMunicipio(e) {
      this.$router.replace(`/cidade/${e}`);
      this.$emit("realod");
    },
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "city",
      "uf",
      "cityId",
      "urlTag",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin",
      "isNA",
      "isIndicadores",
      "isSala",
      "isAT",
    ]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";

.cityName {
  display: flex;
  align-items: center;
  column-gap: 2rem;
}
</style>
